import { create } from "zustand";
import { fetchLogin } from "./Services/fetchlogin";
import { fetchCreateEmpleado } from "./Services/fetchCreateEmpleado";
import { fetchEmpleados as fetchEmpleadosApi } from "./Services/getEmpleados"; // <- Renombrado aquí
import { fetchUpdateEmpleado } from "./Services/fetchEditEmpleado";
import { fetchDetalleEmpleado } from "./Services/fetchDetalleEmpleado";
import { fetchPresignContrato } from "./Services/fetchPresignContrato";
import { fetchAttachContrato } from "./Services/fetchAttachContrato";
import { fetchChecador } from "./Services/Checadores/getChecadores";

const useStore = create((set, get) => ({
  // — Estado global —
  loading: false,
  loadingCreateEmpleado: false,
  loadingUpdateEmpleado: false,
  error: null,
  errorCreateEmpleado: null,
  errorUpdateEmpleado: null,
  users: [],
  nextKey: null, // <- Ahora usa nextKey, NO lastKey
  routesLoading: false,
  detalleEmpleado: null,
  loadingDetalleEmpleado: false,
  errorDetalleEmpleado: null,

  loadingChecador: false,
  errorChecador: null,
  checador: [],


  resetError: () => set({ error: null }),

  fetchDataLogin: async (body) => {
    set({ loading: true, error: null });
    try {
      await fetchLogin(body);
      set({ loading: false });
    } catch (error) {
      set({
        error: error instanceof Error ? error : new Error("Error desconocido"),
        loading: false,
      });
    }
  },

  fetchCreateEmpleado: async (body, token) => {
    set({ loadingCreateEmpleado: true, errorCreateEmpleado: null });
    try {
      const res = await fetchCreateEmpleado(body, token);
      set({ loadingCreateEmpleado: false });
      return res;
    } catch (error) {
      set({ errorCreateEmpleado: error, loadingCreateEmpleado: false });
      throw error;
    }
  },

  fetchUpdateEmpleado: async (numeroEmpleado, body, token) => {
    set({ loadingUpdateEmpleado: true, errorUpdateEmpleado: null });
    try {
      const res = await fetchUpdateEmpleado(numeroEmpleado, body, token);
      set({ loadingUpdateEmpleado: false });
      return res;
    } catch (error) {
      set({ errorUpdateEmpleado: error, loadingUpdateEmpleado: false });
      throw error;
    }
  },

  fetchPresignContrato: async (numeroEmpleado, token) => {
    try {
      const res = await fetchPresignContrato(numeroEmpleado, token);
      return res;
    } catch (error) {
      throw error;
    }
  },

  fetchAttachContrato: async (numeroEmpleado, body, token) => {
    try {
      const res = await fetchAttachContrato(numeroEmpleado, body, token);
      return res;
    } catch (error) {
      throw error;
    }
  },


  /**
   * Trae empleados con paginación.
   * @param {boolean} append Si true, agrega a la lista actual; si false, reemplaza.
   * @param {string|null} lastKey El nextKey devuelto por el backend.
   */
  fetchEmpleados: async (append = false, lastKey = null) => {
    set({ loading: true, error: null });
    try {
      const { empleados, nextKey } = await fetchEmpleadosApi(lastKey);
      set(state => ({
        users: append ? [...state.users, ...empleados] : empleados,
        nextKey,
        loading: false
      }));
    } catch (error) {
      set({ error: error, loading: false });
    }
  },

  fetchDetalleEmpleado: async (curp, token) => {
    set({ loadingDetalleEmpleado: true, errorDetalleEmpleado: null, detalleEmpleado: null });
    try {
      const detalle = await fetchDetalleEmpleado(curp, token);
      set({ detalleEmpleado: detalle, loadingDetalleEmpleado: false });
      return detalle;
    } catch (error) {
      set({ errorDetalleEmpleado: error, loadingDetalleEmpleado: false });
      throw error;
    }
  },

  fetchChecador: async () => {
    set({ loadingChecador: true, errorChecador: null });
    try {
      const res = await fetchChecador();
      set({
        checador: res.data || [],
        loadingChecador: false,
      });
      return res;
    } catch (error) {
      set({
        errorChecador: error,
        loadingChecador: false,
      });
      throw error;
    }
  },

}));

export default useStore;
